import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell, AreaChart, Area, CartesianGrid } from 'recharts';

const COLORS = ['#10b981','#3b82f6','#f59e0b','#8b5cf6','#06b6d4','#ec4899','#84cc16','#f97316','#6366f1','#ef4444'];

const CustomTooltip = ({ active, payload, color }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-3 shadow-sm text-sm">
      <p className="font-medium text-slate-700">{payload[0].payload.name || payload[0].payload.month}</p>
      <p style={{ color }}>${payload[0].value.toLocaleString('en-AU', { minimumFractionDigits: 2 })}</p>
    </div>
  );
};

export default function ChartExpandModal({ open, onClose, title, data, chartType, color }) {
  const barHeight = Math.max(400, data.length * 36);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-sm font-semibold text-slate-500 uppercase tracking-wide">{title}</DialogTitle>
        </DialogHeader>
        <div style={{ height: chartType === 'bar' ? barHeight : 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            {chartType === 'bar' ? (
              <BarChart data={data} layout="vertical" margin={{ left: 0, right: 60, top: 0, bottom: 0 }}>
                <XAxis
                  type="number"
                  tickFormatter={v => `$${v >= 1000 ? (v / 1000).toFixed(1) + 'k' : v}`}
                  fontSize={11} axisLine={false} tickLine={false}
                />
                <YAxis type="category" dataKey="name" fontSize={11} width={130} axisLine={false} tickLine={false} />
                <Tooltip content={<CustomTooltip color={color} />} />
                <Bar dataKey="amount" radius={[0, 4, 4, 0]} maxBarSize={24} label={{ position: 'right', fontSize: 11, fill: '#64748b', formatter: v => `$${v.toLocaleString('en-AU', { minimumFractionDigits: 2 })}` }}>
                  {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Bar>
              </BarChart>
            ) : (
              <AreaChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="expandGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor={color} stopOpacity={0.15} />
                    <stop offset="95%" stopColor={color} stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
                <XAxis dataKey="month" fontSize={11} axisLine={false} tickLine={false} />
                <YAxis
                  tickFormatter={v => `$${v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v}`}
                  fontSize={11} axisLine={false} tickLine={false}
                />
                <Tooltip content={<CustomTooltip color={color} />} />
                <Area type="monotone" dataKey="amount" stroke={color} fill="url(#expandGradient)" strokeWidth={2} dot={false} />
              </AreaChart>
            )}
          </ResponsiveContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
}